
import {
	Component,
	Vue
} from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Message from '@/components/message.vue';

import {
	freightCompensationStatisList,
	restoreBuyFreightInsurance
} from '@/api/after_sales';
import {
	getSearchDate,
	nextDay
} from "@/utils/index"


@Component({
	name: 'order-product',
	components: {
		PageFooter,
		PickerDate,
		'slz-message': Message,
	}
})
export default class OrderProduct extends Vue {
	private defThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png'
	private productNameKey = ''
	private IDKey = ''
	private list: any[] = [];
	private pageNo = 1;
	private pageSize = 10;
	private total = 0;
	private filterTime: any = ''
	private tableloading = false;
	private showMessage = false;
	private itemData: any = {};

	private mounted() {
		this.recently30()
		this.getList()
	}

	private recently30() {
		this.filterTime = [getSearchDate(1, false)[0], getSearchDate(1, false)[1]].join('/')
	}


	private changePage(e) {
		this.pageNo = e
		this.getList()
	}

	private handleBack(){
		this.$router.back();
	}

	private async getList() {
		let param: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			Keywords: this.productNameKey,
		}
		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			param.StartTime = dt[0];
			param.EndTime = nextDay(dt[1], 1)
		}
		// if (this.IDKey) {
		// 	param.ProductId = +this.IDKey
		// }
		// if (this.productNameKey) {
		// 	param.Keywords = this.productNameKey
		// }
		try {
			this.tableloading = true
			const res: any = await freightCompensationStatisList(param);
			this.list = res.Result.Results;
			this.total = res.Result.Total;
		} catch (e) {
			console.log(e)
		} finally {
			this.tableloading = false
		}
	}
	private handleExport(){
		var url = location.origin + '/pc/orderSupport/freightCompensationStatisList?Keywords=' + (this.productNameKey);
      
		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			url += '&StartTime=' + dt[0];
			url += '&EndTime=' + nextDay(dt[1],1);
		}
		// console.log(url);
		// return;
      	window.open(url)
	}

	private doSearch() {
		this.pageNo = 1;
		this.getList();
	}

	private clearSearch() {
		this.IDKey = ''
		this.pageNo = 1;
		this.productNameKey = ''
		// this.filterTime = getSearchDate(1).join('/')
		this.recently30()
		this.getList()
	}

	private handleRebuy(record: any) {
		this.itemData = record;
		this.showMessage = true;
	}
	private async handleConfirm() {
		try {
			const res: any = await restoreBuyFreightInsurance({
				MemberId: this.itemData.Id
			})

			this.$message({
				type: 'success',
				message: '操作成功！'
			})
			this.getList();
		} catch (error) {

		}
	}
}
